//product light box slider js
$(document).ready(function() {
            var initialImageSrc; // Variable to store the initial image src
            var initialIndex; // Variable to store the initial index
            var currentIndex; // Variable to store the current index

            // Get the initial active image and index on page load
            var $activeItem = $('.product__media-item.is-active');
            if ($activeItem.length > 0) {
                initialImageSrc = $activeItem.find('img').attr('src'); // Set initial src from active item
                initialIndex = $activeItem.index(); // Set initial index from active item
                currentIndex = initialIndex; // Set current index to initial index
                $('.ib-modal-prod-div img').attr('src', initialImageSrc); // Set modal image to active image src by default
            }

            // Function to update the modal image and indices based on the active item
            function updateModalImage() {
                var $activeItem = $('.product__media-item.is-active');
                if ($activeItem.length > 0) {
                    var newImageSrc = $activeItem.find('img').attr('src');
                    
                    var $modalInnerDiv = $('.ib-modal-prod-div-inner');
                    $modalInnerDiv.css('opacity', '0'); // Start fade-out

                    setTimeout(function() {
                        $('.ib-modal-prod-div img').attr('src', newImageSrc); // Change the image src
                        $modalInnerDiv.css('opacity', '1'); // Fade-in
                    }, 300); // Match this duration with the CSS transition duration
                }
            }

            // Create a MutationObserver instance to watch for changes in the DOM
            var observer = new MutationObserver(function(mutationsList) {
                mutationsList.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        // Check if the mutation target is a product media item
                        if ($(mutation.target).hasClass('product__media-item')) {
                            // Update the modal image and indices if the active class has changed
                            updateModalImage();
                        }
                    }
                });
            });

            // Configuration for the observer (observe changes to attributes)
            var observerConfig = {
                attributes: true,
                subtree: true,
                attributeFilter: ['class']
            };

            // Start observing the document for changes in .product__media-item elements
            $('.product__media-item').each(function() {
                observer.observe(this, observerConfig);
            });

            // Function to initialize the lightbox
            function initializeLightbox() {
                // Remove any previously attached event listeners to avoid duplication
                $('.ib-custom-prod-light-box .product__media img').off('click');
                $('.ib-prod-cross, .ib-modal-prod-div').off('click');
                $('.ib-prod-next-arrow').off('click');
                $('.ib-prod-prev-arrow').off('click');

                // Show the modal with the clicked image
                $('.ib-custom-prod-light-box .product__media img').on('click', function() {
                    initialImageSrc = $(this).attr('src'); // Store the initial src when opening the modal
                    initialIndex = $(this).closest('.product__media-item').index(); // Store the initial index
                    currentIndex = initialIndex; // Set current index to initial index

                    $('.ib-modal-prod-div img').attr('src', initialImageSrc);
                     $('.ib-modal-prod-div').hide().fadeIn(300);
                    $('.ib-modal-prod-div').css('display', 'flex');
                });

                $('.ib-prod-cross, .ib-modal-prod-div').on('click', function() {
                    $('.ib-modal-prod-div').css('display', 'none');

                    if (initialImageSrc) {
                        $('.ib-modal-prod-div img').attr('src', initialImageSrc);
                    }

                    currentIndex = initialIndex; // Reset current index to initial index
                });

                // Prevent closing modal when clicking inside the modal content
                $('.ib-modal-prod-div-inner').on('click', function(event) {
                    event.stopPropagation();
                });

                var $items = $('.product__media-item');
                var itemCount = $items.length;

                function updateNextImage() {
                    var $modalInnerDiv = $('.ib-modal-prod-div-inner');
                    $modalInnerDiv.css('opacity', '0'); // Start fade-out
                  currentIndex = (currentIndex + 1) % itemCount;
                        var nextImageSrc = $items.eq(currentIndex).find('img').attr('src');
$('.ib-modal-prod-div img').attr('src', nextImageSrc); // Change the image src
                    
                        
                        
                        $modalInnerDiv.css('opacity', '1'); // Fade-in
                    
                }

                function updatePrevImage() {
                    var $modalInnerDiv = $('.ib-modal-prod-div-inner');
                    $modalInnerDiv.css('opacity', '0'); // Start fade-out
                  currentIndex = (currentIndex - 1 + itemCount) % itemCount;
                        var prevImageSrc = $items.eq(currentIndex).find('img').attr('src');
$('.ib-modal-prod-div img').attr('src', prevImageSrc); // Change the image src
                        
                        $modalInnerDiv.css('opacity', '1'); // Fade-in
                 
                }
              function animateArrowOpacity($arrow) {
            // Animate the opacity of the arrow
            $arrow.css('opacity', '0'); // Start fade-out
            setTimeout(function() {
                $arrow.css('opacity', '1'); // Fade-in
            }, 500); // Match this duration with the CSS transition duration
        }

                $('.ib-prod-next-arrow').click(function() {
                  animateArrowOpacity($(this));  
                  updateNextImage();
                });

                $('.ib-prod-prev-arrow').click(function() {
                  animateArrowOpacity($(this));  
                  updatePrevImage();
                });
            }

            // Initialize the lightbox on page load
            initializeLightbox();

            // Initial setup: trigger the update once on page load
            updateModalImage();
  });


//extended warranty detail js
$(document).ready(function() {
  $(".extended-warranty-details").click(function() {
       $(".details-for-extend-warranty").slideToggle();
  });
});


// Product Options/Variants js - updated code with price 16-03-2026
$(document).ready(function() {

  function getPrice() {
    const el = document.querySelector('.ib-sh-price-sale .money');
    if (!el) return '';
    for (const node of el.childNodes) {
      if (node.nodeType === 3 && node.textContent.trim() !== '') {
        return node.textContent.trim();
      }
    }
    return el.textContent.trim();
  }

  function getCompareAtPrice() {
    const el = document.querySelector('.price__sale s.price-item--regular .money');
    if (!el) return '';
    for (const node of el.childNodes) {
      if (node.nodeType === 3 && node.textContent.trim() !== '') {
        return node.textContent.trim();
      }
    }
    return el.textContent.trim();
  }

  function getSelectedVariantText() {
    const $checkedRadio = $('input[name="Select Length:"]:checked, input[name="Select length"]:checked');
    const $label = $checkedRadio.next('label');
    return $label.contents().filter(function() {
      return this.nodeType === 3;
    }).text().trim();
  }

  function syncCompareAtVisibility() {
    const salePrice = getPrice();
    const comparePrice = getCompareAtPrice();

    if (!comparePrice || salePrice === comparePrice) {
      $('.ib-prod-selected-compare-at-price').hide();
    } else {
      $('.ib-prod-selected-compare-at-price').show();
    }
  }

  function updateDisplay() {
    $('.ib-prod-selected-variant').text(getSelectedVariantText());
    $('.ib-prod-selected-price').text(getPrice());
    $('.ib-prod-selected-compare-at-price').text(getCompareAtPrice());
    syncCompareAtVisibility();
  }

  // Single shared poll reference so we can cancel it
  let activePoll = null;

  function waitForPriceChange(previousPrice) {
    if (activePoll) clearInterval(activePoll);

    let attempts = 0;
    const maxAttempts = 30;

    activePoll = setInterval(function() {
      const newPrice = getPrice();
      attempts++;

      if (newPrice !== previousPrice || attempts >= maxAttempts) {
        clearInterval(activePoll);
        activePoll = null;
        updateDisplay();
      }
    }, 50);
  }

  // On radio change
  $(document).on('change', 'input[name="Select Length:"], input[name="Select length"]', function() {
    $('.ib-prod-selected-variant').text(getSelectedVariantText());
    const previousPrice = getPrice();
    waitForPriceChange(previousPrice);
  });

  // Initial load
  updateDisplay();

  // Observe both price elements for DOM changes
  function observeNode(selector) {
    const targetNode = document.querySelector(selector);
    if (targetNode) {
      let observerTimeout;
      const observer = new MutationObserver(function() {
        if (activePoll) {
          clearInterval(activePoll);
          activePoll = null;
        }
        clearTimeout(observerTimeout);
        observerTimeout = setTimeout(function() {
          updateDisplay();
        }, 100);
      });

      observer.observe(targetNode, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  observeNode('.ib-sh-price-sale .money');
  observeNode('.price__sale .price-item--regular .money');
});

// Product Options/Variants js - old code
// $(document).ready(function() {
  
//   function updateSelectedVariant() {
//     // Get the checked radio input
//     const $checkedRadio = $('input[name="Select Length:"]:checked');
    
//     // Get the corresponding label
//     const $label = $checkedRadio.next('label');

//     const selectedVariantText = $label.contents().filter(function() {
//       return this.nodeType === 3;
//     }).text().trim();

//     $('.ib-prod-selected-variant').text(selectedVariantText);
    
//   }

//   updateSelectedVariant();

//   $('input[name="Select Length:"]').change(function() {
//     updateSelectedVariant();
//   });
// });


// need length and gram fancybox
$(document).ready(function() {
    $(".fancybox").fancybox();
});


// // code to scroll down to recomended add on - add to cart
// $(document).ready(function() {
//     // Select all buttons with the class 'scrollButton'
//     const buttons = document.querySelectorAll(".ib-sh-cartbuttonsticky");

//     // Add an event listener to each button
//     buttons.forEach(button => {
//         button.onclick = function() {
//              if (window.innerWidth <= 479) {
//                 const targetElement = document.getElementById("ib-sh-prod-add-on");
//                 const offset = 400; // Gap in pixels

//                 // Scroll to the element with an offset
//                 window.scrollTo({
//                     top: targetElement.getBoundingClientRect().top + window.pageYOffset - offset,
//                     behavior: 'smooth'
//                 });
//             }
//         };
//     });

//   });

$(document).ready(function() {
    // Select all buttons with the class 'scrollButton'
    $('.ib-sh-cartbuttonsticky').on('click', function() {
        if (window.innerWidth <= 479) {
            const targetElement = $('#ib-sh-prod-add-on');

            // Add margin to the target element
            const offset = 240;

            // Scroll to the target element without additional offset
            $('html, body').animate({
                scrollTop: (targetElement.offset().top - offset)
            }, 500);
        }
    });
});


// Function to add extended warranty product to cart
$(document).ready(function() {
    function addToCart(variantId, quantity) {
        console.log(`Adding variant ${variantId} with quantity ${quantity} to cart`);
        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                id: variantId,
                quantity: quantity
            }),
            dataType: 'json',
            success: function(data) {
                console.log('Product added to cart:', data);
            },
            error: function(xhr, status, error) {
                console.error('Error adding product to cart:', error);
            }
        });
    }

    $('#40148620673112').on('change', function() {
        console.log('Checkbox 40148620673112 changed:', this.checked);
        if (this.checked) {
            addToCart(40148620673112, 1);
        }
    });

    $('#40146849497176').on('change', function() {
        console.log('Checkbox 40146849497176 changed:', this.checked);
        if (this.checked) {
            addToCart(40146849497176, 1);
        }
    });
});


//need lenght and gram related
$(document).ready(function() {
    var isEventBound = false;

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if ($('.fancybox-stage').length > 0) {             
                if (!isEventBound) {
                    
                    $(document).on('click', '.fancybox-stage', function(event) {
                        // Check if the click event target is exactly .fancybox-stage
                        if (event.target === this) {
                            $('.fancybox-close-small').click();
                        }
                    });

                    isEventBound = true; // Set the flag to true
                }

                observer.disconnect();
            }
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
});

//add to cart ass color div
 $(document).ready(function() {
    // Check if the device width is 479px or less
    var isMobile = window.matchMedia('only screen and (max-width: 479px)').matches;

    if (isMobile) {
      // Add the temporary class to the element with class 'ib-sh-page-padding'
      $('.ib-sh-page-padding').addClass('temp-fixed-cart-button');

      // Calculate the position of the 'Add to Cart' button
      var addToCartWrapperPos = $('.product-form__buttons').offset().top + 41;

      // Add scroll event listener
      $(window).on('scroll', function () {
        var scroll = $(window).scrollTop();
        // Toggle classes based on scroll position
        if (scroll >= addToCartWrapperPos) {
          $('.product-form__buttons').addClass('with-padding');
          $('.ib-sh-page-padding').addClass('add-to-cart-fixed');
        } else {
          $('.product-form__buttons').removeClass('with-padding');
          $('.ib-sh-page-padding').removeClass('add-to-cart-fixed');
        }
      });

      // Add click event listener to the 'ib-sh-cartbuttonsticky' inside 'product-form__buttons'
      $('.product-form__buttons .ib-sh-cartbuttonsticky').on('click', function() {
        $('.fixed-product-info').addClass('item-added');
         $('.ib-sh-page-padding').addClass('temp-cart-button');
      });
    }
  });




window.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.for-sticky-cartbtn');
    var button = document.querySelector('.ib-sh-cartbuttonsticky');
    if (!section || !button) return;  // Exit if elements are not found

    // Function to check if button should be sticky or not
    function checkStickyButton() {
        var sectionBounds = section.getBoundingClientRect();
        if (sectionBounds.bottom <= window.innerHeight + 150) {
            button.classList.remove('ibat-sticky-btn');
        } else {
            button.classList.add('ibat-sticky-btn');
        }
    }

    // Initial check after DOM content is loaded
    requestAnimationFrame(checkStickyButton);

    // Scroll event handler with requestAnimationFrame
    var isScrolling;
    window.addEventListener('scroll', function() {
        if (isScrolling) return;
        isScrolling = true;

        // Debounce the scroll events
        setTimeout(function() {
            requestAnimationFrame(function() {
                checkStickyButton();
                isScrolling = false;  // Reset scrolling flag
            });
        }, 100);  // Adjust this value for responsiveness
    });

    // Listen for window resize in case layout changes
    window.addEventListener('resize', function() {
        requestAnimationFrame(checkStickyButton);
    });
});




